export default {
  get_class_type: (state) => state.class_type,
};
